import { getThemes } from '@aon-coverwallet/cw-react-components';

const rcThemes = getThemes();
const selectTheme = themeId => {
  const themeName = themeId === 'cw' ? 'coverwallet' : themeId;
  if (!themeId) {
    return {
      ...rcThemes['aon'].rc,
      name: themeName,
    };
  }
  return {
    ...rcThemes[themeName].rc,
    name: themeName,
  };
};

export { selectTheme };
